import React from "react";
import { ButtonProps, IconButton, Button, IconButtonProps, FabProps, Fab } from "@mui/material";

// ------------------ MAIN BUTTON ------------------
export type WcButtonProps = ButtonProps & {
  controlDisabled?: boolean;
};

export const WcButton = ({ controlDisabled = false, sx, ...props }: WcButtonProps) => (
  <Button data-testid="button" disabled={controlDisabled} sx={[...(Array.isArray(sx) ? sx : [sx])]} {...props} />
);

// ------------------ ICON BUTTON EXPORT ------------------

export type WcIconButtonProps = IconButtonProps & {
  controlDisabled?: boolean;
};

export const WcIconButton = React.forwardRef(({ controlDisabled = false, sx, ...props }: WcIconButtonProps, ref: any) => (
  <IconButton data-testid="icon-button" ref={ref} disabled={controlDisabled} sx={[...(Array.isArray(sx) ? sx : [sx])]} {...props} />
));
// ------------------------------------------------------

// ------------------ FLOATING ACTION BUTTON EXPORT ------------------

export type WcFabProps = FabProps & {
  controlDisabled?: boolean;
};

export const WcFab = React.forwardRef(({ controlDisabled = false, sx, ...props }: WcFabProps, ref: any) => (
  <Fab data-testid="fab-button" ref={ref} disabled={controlDisabled} sx={[...(Array.isArray(sx) ? sx : [sx])]} {...props} />
));
// ------------------------------------------------------

export default WcButton;
